function Card(
  props: Readonly<{
    variant?: string;
    extra?: string;
    children?: JSX.Element | any[];
    [x: string]: any;
  }>
) {
  const { variant, extra, children, ...rest } = props;

  return (
    <div
      className={`  relative flex flex-col rounded-[20px] bg-white bg-clip-border shadow-3xl ${
        props.default
          ? "shadow-shadow-500 dark:shadow-md"
          : "shadow-shadow-100 dark:shadow-md"
      }  dark:!bg-navy-800 dark:text-white  ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
